// extracted by mini-css-extract-plugin
export default {"countdown":"Timer_countdown__wwzAn"};